// removed by extract-text-webpack-plugin
module.exports = {"usefulQuestions":"_3ptCv iw2TU _3bI9n"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/UsefulQuestions.css
// module id = 1189
// module chunks = 3